import { DigitalOnboardingStatus } from '../../../../../generated/tenant-api';
import { DisplayStep } from '../../AutofulfillStepper';
import { NextRouter } from 'next/router';
import { EMRConfigData, ModalControls } from '../RRAOnboardingTracker';
import { UserWithPermissions } from '../../../../../lib/user';

const qcStep = (onboardingStatus: DigitalOnboardingStatus, router: any) => {
    const QC_IN_PROGRESS_STATUSES = new Set<DigitalOnboardingStatus>([
        DigitalOnboardingStatus.CREDENTIALS_SUBMITTED,
        DigitalOnboardingStatus.QC_STARTED,
        DigitalOnboardingStatus.QC_FAILED,
    ]);

    return {
        title: 'Quality Check',
        statuses: [
            DigitalOnboardingStatus.CREDENTIALS_SUBMITTED, // Athena A+C Form Completed
            DigitalOnboardingStatus.QC_STARTED,
            DigitalOnboardingStatus.QC_READY,
            DigitalOnboardingStatus.QC_COMPLETED,
            DigitalOnboardingStatus.QC_FAILED,
        ],
        tooltip: QC_IN_PROGRESS_STATUSES.has(onboardingStatus)
            ? 'Quality Control testing results are being prepared for your review. Once ready, please prioritize this step to avoid delays in Go Live.'
            : undefined,
        onClick:
            onboardingStatus === DigitalOnboardingStatus.QC_READY
                ? () => router.push('/autofulfill/quality-check')
                : undefined,
    };
};

export const LightWeightTrackerSteps = (props: {
    isSideNavOpen: boolean;
    configData: EMRConfigData;
    currentUser: UserWithPermissions;
    router: NextRouter;
    modalControls: ModalControls;
}): DisplayStep[] => {
    const onboardingStatus = props.configData.onboardingStatus;

    const lightweightSteps: DisplayStep[] = [
        {
            title: 'Complete Agreement',
            onClick: () => props.modalControls.setIsAgreementModalOpen(true),
            statuses: [DigitalOnboardingStatus.EMR_SUBMITTED],
            pendoId: 'lightWeightSignAgreementViaDocuSign',
        },
        {
            title: 'Continue Setup',
            onClick: () => props.modalControls.setIsNextStepsModalOpen(true),
            statuses: [DigitalOnboardingStatus.DOCUSIGN_COMPLETED],
            tooltip:
                onboardingStatus === DigitalOnboardingStatus.DOCUSIGN_COMPLETED
                    ? 'Please note this step may require Datavant review before being marked as complete.'
                    : undefined,
        },
        qcStep(onboardingStatus, props.router),
        {
            title: 'Go Live',
            statuses: [],
        },
    ];

    return lightweightSteps;
};
